var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_13662)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_461_13662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_461_13662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2407 30.6409C32.7716 35.9249 26.7932 39.4141 19.9999 39.4141C9.27789 39.4141 0.585938 30.7221 0.585938 20C0.585938 17.1404 1.20414 14.4252 2.3143 11.9807",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47461 9.80488C6.89523 4.27199 13.017 0.585431 19.9997 0.585431C30.7219 0.585431 39.4137 9.27746 39.4137 19.9995C39.4137 23.1051 38.6845 26.0404 37.388 28.6436",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1673 20.0004C34.1673 27.8243 27.8246 34.167 20.0006 34.167C12.1766 34.167 5.83398 27.8243 5.83398 20.0004C5.83398 12.1764 12.1766 5.83371 20.0006 5.83371C27.8246 5.83371 34.1673 12.1764 34.1673 20.0004Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959 20.5149H24.2037",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1445 23.7988H26.8545",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7959 27.083H24.2037",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0827 14.9996C22.0827 16.1503 21.1499 17.083 19.9993 17.083C18.8487 17.083 17.916 16.1503 17.916 14.9996C17.916 13.849 18.8487 12.9163 19.9993 12.9163C21.1499 12.9163 22.0827 13.849 22.0827 14.9996Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.663711V5.4834",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.832 8.8584L32.226 4.9202",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66602 5.00707L11.035 8.8584",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 34.2168L10.2927 30.317",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 34.1663L20.2441 39.4121",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8945 30.5873L33.11 34.3184",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_13662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayMeasure);
export default __webpack_public_path__ + "static/media/displayMeasure.d3f6b135387b8d8d0028ed273ec7e11f.svg";
export { ForwardRef as ReactComponent };